import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PAGE_NAME } from "../../types";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { THEME_COLORS } from "../themes/DarkLight";
import Text from "./ThemedText";

const GrantAvailableCard = ({ nextGrantValue }: { nextGrantValue: number }) => {
  const theme = useThemeHook();
  const navigate = useNavigate();
  const getTranslationText = useTranslationHook();

  useEffect(() => {
    // Pulse animation via CSS
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @keyframes pulse-subtle {
        0%, 100% { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
        50% { box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
      }
      .pulse-card {
        animation: pulse-subtle 2s infinite;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  function goToGrantPage(): void {
    navigate(PAGE_NAME.CLAIM_GRANT);
  }

  return (
    <div
      className={`pulse-card bg-transparent border ${
        theme === "dark" ? "border-neutral-600" : "border-yellow-300"
      } rounded-2xl p-6 cursor-pointer hover:${
        theme === "dark" ? "border-neutral-500" : "border-yellow-400"
      } transition-all`}
      onClick={goToGrantPage}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-100">
            <Text text="G" style={{ color: "white", fontSize: 20, fontWeight: "600" }} />
          </div>

          <div>
            <Text text={getTranslationText("grant_available")} style={{ fontSize: 14, marginBottom: 2, color: theme === "dark" ? "neutral-400" : "gray-500" }} />
            <Text text={`${nextGrantValue?.toFixed(2)} Arthereum`} style={{ fontSize: 18, fontWeight: "600", color: theme === "dark" ? "neutral-100" : "gray-900" }} />
          </div>
        </div>

        <Text text={getTranslationText("claim")} style={{ fontSize: 16, fontWeight: "500", color: THEME_COLORS[theme].gold }} />
      </div>
    </div>
  );
};

export default GrantAvailableCard;
